export const timer = (delayInMs: number) =>
  new Promise((resolve) => setTimeout(resolve, delayInMs));
